import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Input,
  CustomInput,
  DropdownItem,
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import get from 'lodash/get'
import find from 'lodash/find'
import shortid from 'shortid'
import styled from 'styled-components'
import { customStyles, invalidStyles } from '../../../../constants'

class ProjectForm extends React.Component {
  render() {
    const { open, toggle, keyPress } = this.props
    const companys = [{ label: '', _id: '' }, ...get(this.props, 'companys', [])]
    let lobs = [{ label: '', _id: '' }, ...get(this.props, 'lobs', [])]
    let departments = [{ label: '', _id: '' }, ...get(this.props, 'departments', [])]

    if (get(this.props, 'company_id') !== '' && get(this.props, 'lobs') !== undefined) {
      lobs = get(this.props, 'lobs').filter((element) => {
        return element.company_id === get(this.props, 'company_id') && element.is_active === true
      })
      lobs = [{ label: '', _id: '' }, ...lobs]
    } else lobs = [{ label: '', _id: '' }]
    if (get(this.props, 'lob_id') !== '' && get(this.props, 'departments') !== undefined) {
      departments = get(this.props, 'departments').filter((element) => {
        return element.lob_id === get(this.props, 'lob_id')
      })
      departments = [{ label: '', _id: '' }, ...departments]
    } else departments = [{ label: '', _id: '' }]

    // filter managers and approvers (should not be the same person)
    const managers = get(this.props, 'managers').filter(manager => {
      const found = find(get(this.props, 'project_approvers'), { _id: manager._id })
      if (!found) return manager
      return null
    })
    const approvers = get(this.props, 'approvers').filter(approver => {
      const found = find(get(this.props, 'project_managers'), { _id: approver._id })
      if (!found) return approver
      return null
    })

    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        size='lg'
        isOpen={ open }
        toggle={ () => toggle() || keyPress() }
      >
        <ModalHeader
          toggle={ () => toggle() || keyPress() }
        >
          <HeadLabel>Project Information</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Root>
            <Row>
              <Col sm="12">
                <Form onSubmit={ (e) => e.preventDefault() }>
                  <FormGroup>
                    <Container >
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Project Manager *</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          <SelectInputField
                            isMulti
                            styles={ get(this.props, 'project_managers.length') === 0 ? invalidStyles : customStyles }
                            name='project_managers'
                            value={ get(this.props, 'project_managers') }
                            options={ managers }
                            onChange={ get(this.props, 'handleProjectManager') }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Key PM*</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          <SelectInputField
                            styles={ get(this.props, 'key_project_manager') ? customStyles : invalidStyles }
                            name='key_project_manager'
                            value={ get(this.props, 'key_project_manager') }
                            options={ get(this.props, 'project_managers') }
                            onChange={ get(this.props, 'handleKeyPM') }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Additional Approver</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          <SelectInputField
                            isMulti
                            styles={ customStyles }
                            name='project_approvers'
                            value={ get(this.props, 'project_approvers') }
                            options={ approvers }
                            onChange={ get(this.props, 'handleProjectApprover') }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Project Type *</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          {
                            <CustomInputField
                              type="select"
                              id="project_type"
                              name="project_type"
                              value={ get(this.props, 'project_type') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                get(this.props, 'project_types', []).map((g) => (
                                  <option key={ shortid() } value={ g.value }>{ g.label }</option>)
                                )
                              }
                            </CustomInputField>
                          }
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Client *</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          <SelectInputField
                            styles={ get(this.props, 'client.length') === 0 ? invalidStyles : customStyles }
                            type="select"
                            id="client"
                            name="client"
                            options={ get(this.props, 'clients') }
                            value={ get(this.props, 'client') }
                            onChange={ this.props.handleClient }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Project Name *</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="project_name"
                            invalid={ get(this.props, 'project_name') === '' }
                            value={ get(this.props, 'project_name') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >PM Supervisor</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          {
                            <SelectInputField
                              styles={ customStyles }
                              type="select"
                              id="pm_supervisor"
                              name="pm_supervisor"
                              options={ get(this.props, 'pm_supervisors') }
                              value={ get(this.props, 'pm_supervisor') }
                              onChange={ this.props.handleSupervisor }
                            />
                          }
                        </Col>
                      </Row>
                      <DropdownItem divider />
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Company</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          {
                            <CustomInputField
                              type="select"
                              id="company_id"
                              name="company_id"
                              invalid={ get(this.props, 'company_id') === '' }
                              value={ get(this.props, 'company_id') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                companys.map((g) =>
                                  <option key={ shortid() } value={ g._id }>{ g.name }</option>
                                )
                              }
                            </CustomInputField>
                          }
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >LOB</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          {
                            <CustomInputField
                              type="select"
                              id="lob_id"
                              name="lob_id"
                              invalid={ get(this.props, 'lob_id') === '' }
                              value={ get(this.props, 'lob_id') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                lobs.map((g) =>
                                  <option key={ shortid() } value={ g._id }>{ g.name }</option>
                                )
                              }
                            </CustomInputField>
                          }
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Department</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          {
                            <CustomInputField
                              type="select"
                              id="department_id"
                              name="department_id"
                              value={ get(this.props, 'department_id') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                departments.map((g) =>
                                  <option key={ shortid() } value={ g._id }>{ g.name }</option>
                                )
                              }
                            </CustomInputField>
                          }
                        </Col>
                      </Row>
                      <DropdownItem divider />
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Start Date *</TextLabel>
                        </Col>
                        <Col sm={ 3 } style={ { paddingLeft: '5px' } }>
                          <ColDate>
                            <ProjectDatePicker
                              autoComplete='off'
                              onChange={ this.props.handleChangeStartDate }
                              name="start_date"
                              placeholderText='DD/MM/YYYY'
                              selected={ get(this.props, 'start_date') === '' ? '' : get(this.props, 'start_date') }
                              dateFormat="DD/MM/YYYY"
                              showYearDropdown
                              showMonthDropdown
                            />
                          </ColDate>
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >End Date *</TextLabel>
                        </Col>
                        <Col sm={ 3 } style={ { paddingLeft: '5px' } }>
                          <ColDate>
                            <ProjectDatePicker
                              autoComplete='off'
                              onChange={ this.props.handleChangeEndDate }
                              name="end_date"
                              placeholderText='DD/MM/YYYY'
                              selected={ get(this.props, 'end_date') === '' ? '' : get(this.props, 'end_date') }
                              dateFormat="DD/MM/YYYY"
                              showYearDropdown
                              showMonthDropdown
                            />
                          </ColDate>
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <TextLabel >Remarks</TextLabel>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            id="remarks"
                            name="remarks"
                            value={ get(this.props, 'remarks') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                    </Container>
                  </FormGroup>
                </Form>
              </Col>
            </Row>
          </Root>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

ProjectForm.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
  keyPress: PropTypes.func,
  handleChangeEndDate: PropTypes.func,
  handleChangeStartDate: PropTypes.func,
  handleSupervisor: PropTypes.func,
  handleClient: PropTypes.func,
  handleInput: PropTypes.func,
}
ProjectForm.defaultProps = {
  open: false,
  toggle: () => {},
  keyPress: () => {},
  handleChangeEndDate: () => {},
  handleChangeStartDate: () => {},
  handleSupervisor: () => {},
  handleClient: () => {},
  handleInput: () => {},
}

export default ProjectForm

const Root = styled.div`
  .custom-select.is-invalid,
  .was-validated .custom-select:valid,
  .custom-select.is-invalid,
  .was-validated .custom-select:invalid {
    background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px;
  }

  .form-control.is-invalid {
    background: none;
  }
`

const SelectInputField = styled(Select)`
  font-family: Gotham;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 16px ;
  color: #AD2624;
`
const TextLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 16px ;
  color: #333333;
  margin-bottom: 0px ;
`
const CustomInputField = styled(CustomInput)`
  font-family: Gotham;
  width : 100%;
  height : 100%;
  font-size: 12px;
`
const InputField = styled(Input)`
  font-family: Gotham;
  width : 100% ;
  font-size: 12px ;
`
const ColDate = styled(Col)`
  width : 100% ;
  height : 55% ;
  padding-left: 10px;
  padding-right: 0px;
`
const ProjectDatePicker = styled(DatePicker)`
  font-family: Gotham;
  width : 150px;
  height : 30px;
  font-size: 12px;
  padding-left: 5%;
  float: right;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
@media (max-width: 575.98px) {
    width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/new-project/index.js